"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockSavedCustomInternalTemplate = exports.mockGetCustomInternalTemplate = void 0;
exports.mockGetCustomInternalTemplate = {
    template: {
        internalTemplateName: 'userInvitation',
        data: {
            header: 'Learn faster, Code safer -- INITIAL STATE',
            content: "Hey! You and your team are invited to use Codebashing training program to secure your existing and future projects! \n      Yes it\u2019s mandatory by your manager\u2019s request, but it\u2019s speedy, interactive and fun!",
            logoUrl: 'https://content.devcodebashing.com/email-template-assets/codebashing.png',
            message: 'Keep up the Bashey vibe! Codebashing team',
            subject: 'You`ve been invited to join Codebashing',
        },
    },
};
exports.mockSavedCustomInternalTemplate = {
    template: {
        internalTemplateName: 'userInvitation',
        data: {
            header: 'Learn faster, Code safer -- RETURN AFTER SAVE',
            content: 'Hey! CHANGED AFTER SAVE',
            logoUrl: 'https://content.devcodebashing.com/email-template-assets/codebashing.png',
            message: 'Bashey vibe! Is the right vibe',
            subject: 'You`ve been invited.....',
        },
    },
};
